<!--减排进度及走势（曲线图）-->
<template>
<div class="er commonborder flex_row">
  <div id="er_line1" class="echarts"></div>
  <!-- <div>
    <el-popover
      placement="top"
      width="2000"
      trigger="manual"
      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
      v-model="visible">
    </el-popover>
  </div> -->
</div>

</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
      visible:false,
    };
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //获取数据
    getList(){
      api.getReduction().then(res=>{
        if(res.code==10000){
          let _data = res.data.list
          let _year = []
          let _num = []
          for(var i in _data){
            _year.push(_data[i].energyYear)
            _num.push(_data[i].energyData)
          }
          this.er_line1(_year.reverse(),_num.reverse())
        }
      })
    },
    er_line1(a,b){
      let er_line1 = echarts.init( document.getElementById('er_line1') );
      // er_line1.on('click', param => pieConsole.call(this, param))
      // function pieConsole(param) {
      //   if (param.seriesIndex !== null && param.seriesIndex !== undefined) {
      //     console.log('点击到了某个数据点', param.value)
      //   } else {
      //    this.visible = true
      //    console.log('点击了x轴的某个刻度值',param.value)
      //   }
      // }
      
      er_line1.setOption({
          color:['#ffea04'],
          tooltip: { 
            trigger: 'axis',
            textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
              type: 'shadow'
            },
            formatter:(params)=>{
              return params[0].name +'<br />'+ params[0].marker+ this.$common.formatNum(params[0].value) + '吨';
            },
          },
          xAxis: {
              type: 'category',
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
              axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
              data: a,
              triggerEvent: true
          },
          yAxis: {
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,formatter: '{value}吨'},
            axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
            // splitNumber:4,
            splitLine:{show:true,lineStyle:this.splitLineStyle},
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
          },
          grid: { left: '4%',right:'12%',top:'16%',bottom:'4%',containLabel: true},
          series: [{
   
              name: '减排量',
              type: 'line',
              data: b,
              symbolSize:8, 
              symbol:'circle',
              // markPoint: {
              //   symbolSize:24,
              //   label:{
              //     color:'#081aa1',fontSize:this.$echartsFontSize
              //   },
              //   data: [
              //       {type: 'max', name: '最大值'},
              //       {type: 'min', name: '最小值'}
              //   ]
              // },
              markLine: {
                  symbolSize:8, 
                  data: [
                      {
                          type: 'average',                          
                          label: {
                              position: 'end',
                              formatter: '碳中和',fontSize:this.$echartsFontSize
                          },
                      }
                  ]
              }
          }] 
      })
      this.$common.moveEcharts(b.length,er_line1)
    },
    
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.er{
  #er_line1{ height: 100%; width: 100%;}
}
</style>